import React from "react";
import { Icons } from "../../atoms/Icons";
import Buttons from "../../atoms/Buttons";
import "./signoutmodal.scss";

const SignoutModal = (props) => {
  return (
    <div className="sign-out-modal">
      <div className="text-end">
        <Icons
          iconname="close"
          variant="icon-twenty-four-px"
          clickHandler={props.handleCloseButton}
        />
      </div>
      <div className="heading mb-4">Sign out</div>
      <div className="sub-text mb-4">
        <p className="sign-out-content">Are you sure you want to sign out?</p>
      </div>
      <div className="text-end">
        <Buttons
          className="secondary me-4"
          name={"Cancel"}
          handleClick={props.handleCloseButton}
        />
        <Buttons
          className={`primary`}
          name={"Confirm"}
          handleClick={props.handleConfirm}
        />
      </div>
    </div>
  );
};

export default SignoutModal;
